import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Box, Rating, Stack, Typography } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { CURRENCY } from "../../constants/Variables";
import { roundTo2Decimal } from "../../utils";
import GlobalButton from "../CustomButton";

const BasePackageProductCard = ({
    cardData,
    colorName,
    cardStyleProps,
    isAlreadyAdded,
    handleQuickView,
}) => {

    const isVariant = cardData.isVariant;
    const discountPrice = isVariant ? cardData.variants?.find(variant => variant?.quantity > 0)?.discount : cardData.discount > 0 ? cardData.discount : 0;
    const finalPrice = isVariant ? cardData.variants?.find(variant => variant?.quantity > 0)?.finalPrice : cardData.finalPrice;
    const productPriceWithDiscount = finalPrice + discountPrice;
    const isOutOfStock = cardData.outOfStock;

    const { currentLanguage } = useSelector((state) => state.languageReducer);

    return (
        <Box
            component="a"
            sx={{
                borderRadius: 2,
                textDecoration: "none",
                position: "relative",
                overflow: "visible",
                cursor: "pointer",
                display: "block",
                backgroundColor: "grey.100",
                ...cardStyleProps,
                "&:hover .card-button": {
                    opacity: 1,
                    visibility: "visible",
                    pointerEvents: "auto",
                },
            }}
        >
            <Box
                position="relative"
                overflow="visible"
                borderRadius={2}
                px={1}
                bgcolor="text.white"
            >
                {isAlreadyAdded && (
                    <CheckCircleIcon
                        sx={{
                            position: "absolute",
                            top: 5,
                            left: 5,
                            zIndex: 999,
                            color: "primary.main",
                        }}
                    />
                )}

                <Box
                    height={180}
                    borderRadius={2}
                    bgcolor="text.white"
                    overflow="hidden"
                    display={"flex"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Box
                        component={"img"}
                        src={cardData?.coverImage}
                        sx={{
                            height: "180px",
                            aspectRatio: 16 / 9,
                            width: "100%",
                            objectFit: "contain",
                            loading: "lazy",
                        }}
                    />
                </Box>
                <Box
                    className="card-button"
                    sx={{
                        position: "absolute",
                        bottom: 12,
                        left: 10,
                        right: 10,
                        opacity: 0,
                        visibility: "hidden",
                        pointerEvents: "none",
                        transition: "opacity 0.25s ease, visibility 0.25s ease",
                        zIndex: 10,
                        textAlign: "center",
                    }}
                >
                    {isOutOfStock ? (
                        <GlobalButton
                            btnText="outOfStock"
                            styleProps={{
                                width: "100%",
                                backgroundColor: "error.main",
                                height: 30,
                            }}
                        />
                    ) : (
                        <GlobalButton
                            btnText={"quickView"}
                            styleProps={{ width: "100%", height: 30, borderRadius: 1 }}
                            handleClickBtn={(e) => {
                                e.stopPropagation();
                                handleQuickView(cardData, isAlreadyAdded);
                            }}
                        />
                    )}
                </Box>
            </Box>

            <Box p={0.5}>
                <Rating
                    name="size-medium"
                    size="small"
                    value={cardData?.rating}
                    readOnly
                    sx={{ mb: 0.5 }}
                />
                <Typography
                    fontSize="1rem"
                    color={colorName || "text.white"}
                    sx={{
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                    }}
                >
                    {cardData.name[currentLanguage]}
                </Typography>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="flex-start"
                    spacing={1}
                >
                    <Typography
                        fontSize="1.125rem"
                        color="text.errorRed"
                        fontWeight={600}
                    >
                        {finalPrice} {CURRENCY}
                    </Typography>
                    {discountPrice > 0 && (
                        <Typography
                            fontSize="1rem"
                            color="error.main"
                            sx={{ textDecoration: "line-through" }}
                        >
                            {roundTo2Decimal(productPriceWithDiscount)} {CURRENCY}
                        </Typography>
                    )}
                </Stack>
            </Box>
        </Box>
    );
};

export default React.memo(BasePackageProductCard);
